import axios from "axios";

const api = axios.create({

  baseURL: 'https://acolhe-pet-ssa-react-spring-production.up.railway.app/api',
  // baseURL: 'http://localhost:8080/api'
});

export default api;